import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const AssignmentFileLink = ({ file, testId }) => {
  const [loading, setLoading] = useState(false);

  if (file.file_data) {
    return (
      <a data-testid={testId} href={file.file_data} download={file.file_name}
        className="inline-flex items-center gap-1 text-teal-700 font-semibold text-xs hover:underline">
        <Download size={13} /> {file.file_name || "Download file"}
      </a>
    );
  }

  const download = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/assignment-files/${file.file_id}`, { responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = file.file_name || "download";
      anchor.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Could not download file");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button type="button" data-testid={testId} onClick={download} disabled={loading}
      className="inline-flex items-center gap-1 text-teal-700 font-semibold text-xs hover:underline disabled:opacity-50">
      <Download size={13} /> {loading ? "Downloading…" : (file.file_name || "Download file")}
    </button>
  );
};